import React from "react";
import {Modal} from "antd5";

import {WizTableForm} from "@/containers/common";

import Import from './components/import'

const positionConfig = WizTableForm.Config.position(this, {apiParams: {state: 1}})
const path = WizTableForm.Config.path(this, { apiParams: { state: 2 } })

//配置项
const componentName = 'trainPathLearningScoreSpecial';
const columns = (self) => {
  return [
    {
      title: '姓名',
      name: "fullName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: '账号',
      name: "userName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "路径",
      name: "pathName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "岗位名称",
      name: "positionName",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "等级",
      name: "lv",
      tableItem: {
        render: (text, record) => `L${text}`
      },
    },
    {
      title: "积分",
      name: "score",
      tableItem: {},
    },
  ];
}

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        btnAccessCheck: false,
        columns: columns(self),
        searchBarProps: {
          cols: {
            xs: 8,
            md: 8,
            xl: 8
          },
          wrappedComponentRef: self._wizTableList_searchRef,
          // dataFormat: (v) => {
          //   const value = Object.assign({}, v)
          //   const {date} = value || {}
          //   value.date = value.date && moment(date).format('YYYY-MM')
          //   return value
          // },
          buttonSort: ['export', 'import', 'delete'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
            {
              key: "import",
              custom: true,
              params: { children: "导入", type: "info" },
              customOnClick: {
                key: "modal",
                params: {
                  modalParams: {
                    title: "导入",
                    destroyOnClose: true,
                    diy: (e) => {
                      const {changeModal} = e || {}
                      return <Import changeModal={changeModal}/>
                    },
                    footer: null,
                    width: 1000
                  }
                }
              },
            },
            {
              key: 'delete',
              custom: true,
              params: { children: '删除', type: 'danger' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'delete'
                },
                formatParams: (rows, record, filters, callback) => {
                  const ids = rows.map(item => item.id)
                  if(!ids?.length) {
                    wizNotice.warn("请至少选择一条数据！");
                    return;
                  }

                  Modal.confirm({
                    title: '注意',
                    content: '您确定要删除选中的数据吗？',
                    onOk: () => {
                      callback && callback({ids})
                    },
                  });
                  return null
                }
              },
              recordChangeParams: ({ record, rows }) => {
                return { disabled: !rows?.length }
              },
            },
          ]
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        modalFormProps: {},
        rowOperateProps: {
          // width: 80,
        },
        rowOperateSort: [],
        rowOperateView: [],
        commonOperate: {}
      }
    }
  };
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/del`,
    payload: {
      key: `${componentName}@del`,
      apiParams: {}
    }
  },
}


let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {columns, reduxTemplateConfig, templateConfig};
